import Vue from 'vue'
import * as ElementUI from 'element-ui'
// import VueI18n from 'vue-i18n'
// import ElementLocale from 'element-ui/lib/locale'
// import messages from '../lang'

export default (() => {
  /**
   * 按需加载组件
   * 需在 COMPONENTS 中引入并保证大写开头
   */
  const COMPONENTS = [
    'Form',
    'FormItem',
    'Icon',
    'Input'
  ]
  for (const name of COMPONENTS) {
    if (ElementUI[name]) {
      Vue.use(ElementUI[name])
    }
  }
  Vue.use(ElementUI.Loading.directive)

  /**
   * 国际化相关
   */
  // const {
  //   locale
  // } = state
  // const i18n = new VueI18n({
  //   locale,
  //   messages
  // })
  // ElementLocale.i18n((key, value) => i18n.t(key, value))
})()
